import { getEntityType } from '@datorama/akita';
import { AbstractFeatureChildQueryEntity, AbstractFeatureChildService } from '@y42/feature';
import {
  AbstractGitEntityState,
  AbstractGitEntityStore,
  AbstractGitFactoryService,
  AbstractGitQueryEntity,
} from '@y42/feature/git/state';
import { Y42FeatureType } from '@y42/json-schema';
import { ImpexChildUIModel, ImpexUIModel } from '../../state';

export abstract class ImpexChildService<
  S extends AbstractGitEntityState = AbstractGitEntityState,
  Entity extends getEntityType<S> = getEntityType<S>,
> extends AbstractFeatureChildService<S, Entity> {
  constructor(config: {
    feature: Y42FeatureType;
    gitFactory: AbstractGitFactoryService;
    store: AbstractGitEntityStore<S>;
    query: AbstractFeatureChildQueryEntity<S>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parentStore: AbstractGitEntityStore<any, any, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parentQuery: AbstractGitQueryEntity<any>;
  }) {
    super(config);
  }

  abstract hasSettings(child: ImpexChildUIModel): Promise<boolean>;
  abstract editSettings(impex: ImpexUIModel, child: ImpexChildUIModel): Promise<void>;
}
